// For Accounts Receivable Setup for Conversion of Schedule Type
// from Open-Item Receivable to Balance-forward Receivable and vice versa

import {
  RowData,
  RowDataReducerState,
  SaveRecordRequest,
  SetupBaseRequestInfo,
  ToastInfo,
} from "../../../../types";
import { ROW_DATA_KEYS, TOAST_MESSAGES } from "../../constants";
import { getUpdatedSetupBaseRequestInfo } from "../rowDataHelpers";

const AR_SCHEDULE_CODE: Map<string, string[]> = new Map([
  [
    "Open-Item Receivable",
    ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  ],
  [
    "Balance-forward Receivable",
    ["N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y"],
  ],
]);

const AR_SCHEDULE_TYPE: Map<string, string> = new Map([
  ["Open-Item Receivable", "AR_OPEN"],
  ["Balance-forward Receivable", "AR_BAL"],
]);

const AR_CONVERSION_SUB_TYPES: Map<string, string> = new Map([
  ["Open-Item Receivable", "Balance-forward Receivable"],
  ["Balance-forward Receivable", "Open-Item Receivable"],
]);

export const canConvertARRecordScheduleType = (
  isReadOnly: boolean | undefined,
  rowData: RowData,
): boolean => {
  return (
    !isReadOnly &&
    rowData[ROW_DATA_KEYS.CONVERSION_STATUS] !== "InProgress" &&
    Object.keys(rowData).includes(ROW_DATA_KEYS.CREATED_BY)
  );
};

export const prepareARScheduleTypeConversionRequest = (
  rowDataReducerState: RowDataReducerState,
  rowData: RowData,
  selectedTabSectionKey: string | undefined,
  setupBaseRequestInfo: SetupBaseRequestInfo,
  setRecordPageToast: (toast: ToastInfo) => void,
): SaveRecordRequest => {
  const updatedSetupBaseRequestInfo = getUpdatedSetupBaseRequestInfo(
    setupBaseRequestInfo,
    selectedTabSectionKey,
    undefined,
  );

  const request: SaveRecordRequest = {
    ...updatedSetupBaseRequestInfo,
    record: getUpdatedARConversionRowData(
      rowData,
      rowDataReducerState.rowDataList,
    ),
  };

  setRecordPageToast(TOAST_MESSAGES.AR_CONVERSION_IN_PROGRESS());

  return request;
};

export const getUpdatedARConversionRowData = (
  rowData: RowData,
  rowDataList: RowData[],
): RowData => {
  const existingSubType = rowData[ROW_DATA_KEYS.SUB_TYPE] as string;
  const newSubtype = AR_CONVERSION_SUB_TYPES.get(existingSubType) ?? null;

  return {
    ...rowData,
    schedule_type: AR_SCHEDULE_TYPE.get(newSubtype ?? "") ?? null,
    [ROW_DATA_KEYS.NEW_SCHEDULE_CODE]: getNewScheduleCode(
      rowDataList,
      newSubtype,
    ),
  };
};

const getNewScheduleCode = (
  rowDataList: RowData[],
  newSubtype: string | null,
): string | null => {
  const scheduleCodeRange = AR_SCHEDULE_CODE.get(newSubtype ?? "");

  const existingScheduleCodes = rowDataList.map(
    (row) => row[ROW_DATA_KEYS.SCHEDULE_CODE] as string,
  );

  return (
    scheduleCodeRange?.find((code) => !existingScheduleCodes.includes(code)) ??
    null
  );
};
